import { ASSETS, LINKS } from "@/constants/assets";

const FOOTER_LINKS = {
  platform: [
    { label: "Intelligent Intake", href: "#services" },
    { label: "Matrix Engine", href: "#domains" },
    { label: "Programs & Protocols", href: "#framework" },
    { label: "Analytics", href: "#technology" },
  ],
  solutions: [
    { label: "Medical Practices", href: "#" },
    { label: "Wellness Centers", href: "#" },
    { label: "Health Clubs", href: "#" },
    { label: "MSOs", href: "#" },
  ],
  company: [
    { label: "About", href: "#" },
    { label: "Implementation", href: "#" },
    { label: "Outcomes", href: "#" },
    { label: "Contact", href: LINKS.jotform, external: true },
  ],
};

export const Footer = () => (
  <footer className="relative z-[1] border-t border-white/[0.08] py-16 px-6 lg:px-12 bg-[rgba(3,11,24,0.95)]" data-testid="footer">
    <div className="max-w-[1200px] mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
      <div>
        <img src={ASSETS.logo} alt="Limitless" className="h-12 w-12 rounded-full mb-3.5 shadow-glow-cyan" />
        <p className="font-outfit text-[14px] leading-relaxed text-white/50 max-w-[280px] font-light">
          AI-powered clinical operating system for modern practices. Intelligent intake, multi-domain analysis, and protocol-driven workflows that unify care.
        </p>
      </div>

      {Object.entries(FOOTER_LINKS).map(([title, links]) => (
        <div key={title}>
          <h4 className="font-orbitron text-[10px] font-semibold tracking-[3px] uppercase text-[#60A5FA] mb-4">
            {title}
          </h4>
          {links.map((link) => (
            <a
              key={link.label}
              href={link.href}
              {...(link.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
              className="block font-outfit text-[14px] text-white/50 no-underline mb-2.5 transition-colors hover:text-white font-light"
            >
              {link.label}
            </a>
          ))}
        </div>
      ))}
    </div>

    <div className="max-w-[1200px] mx-auto mt-9 pt-5 border-t border-white/[0.08] flex flex-col md:flex-row justify-between items-center gap-3">
      <p className="font-outfit text-[12px] text-white/30 font-light">
        © 2025 Limitless Clinical Intelligence — Medical Management Company
      </p>
      <div className="flex gap-6">
        {["Privacy Policy", "Terms of Service", "HIPAA Compliance"].map((item) => (
          <a
            key={item}
            href="#"
            className="text-[12px] text-white/30 no-underline transition-colors hover:text-white font-outfit font-light"
          >
            {item}
          </a>
        ))}
      </div>
    </div>
  </footer>
);
